import { Factory } from "fishery";
import { type CheckPaymentPrefInputType } from "../components/PaymentPrefConsolidated/Components/CheckPaymentPrefInput/constants";

export const checkPaymentPrefInputFactory = Factory.define<CheckPaymentPrefInputType>(() => ({
  payeeName: "John Doe",
  memo: "Payment for services",
  address: {
    sameAsMailingAddress: false,
    streetLine1: "123 Main St",
    streetLine2: "Apt 4B",
    city: "New York",
    state: "NY",
    zip: "10001",
    country: "USA:1",
  },
}));
